import { VerifiedContextState } from '@/features/game-context/store/game-context';
import { GenericProvider, Provider } from '@/features/game-context/types';

const providerNameMap = (): ProviderMap => ({
  RGS: Provider.IGT,
  IGT: Provider.IGT,
  NETENT: Provider.EVOLUTION,
  EVOLUTION: Provider.EVOLUTION,
  EVERI: Provider.EVERI,
  NYX: Provider.LNW,
  HIGH5: Provider.HIGH5,
  DGC: Provider.DGC,
  ARISTOCRAT: Provider.ARISTOCRAT,
  SPINGAMING: Provider.SPINGAMING,
  SPIN: Provider.SPINGAMING,
  EZUGI: Provider.EZUGI,
  REALMS: Provider.REALMS,
  SLINGO: Provider.REALMS,
  PLAYTECH: Provider.PLAYTECH,
  PLAYTECH_POKER: Provider.PLAYTECH_POKER,
  PRAGMATIC: Provider.PRAGMATIC,
  AWAGER: Provider.AWAGER,
  FUSION: Provider.FUSION,
});

export const mapProvider = (
  launchParams: VerifiedContextState,
): Provider | GenericProvider => {
  const { provider } = launchParams;
  const providerMap = providerNameMap()[provider.toUpperCase()];
  if (providerMap) {
    return providerMap;
  }
  return GenericProvider[provider.toUpperCase()];
};

type ProviderMap = {
  [provider: string]: Provider;
};
